import React, { useContext } from 'react'
import { BlockComponent } from 'lib'
import { FallbackContext } from './context'
import { useForceNoHScroll } from 'experiences/dashboard/DashboardRoot/grid/groups/context'
import styled from '@emotion/styled'
import { CardStyle } from 'experiences/dashboard/DashboardRoot/cards'

const useFallback = (key: string) => {
	const { getFallback } = useContext(FallbackContext)
	return getFallback(key)
}

interface Props {
	itemKey: string
	cardStyle: 'card' | 'none'
}
export const FallbackComponent: BlockComponent<Props> = ({ itemKey, cardStyle }) => {
	const { Content, wrapperStyle } = useFallback(itemKey)
	useForceNoHScroll()
	if (wrapperStyle === 'card' && cardStyle === 'none')
		return (
			<CardStyles>
				<Content />
			</CardStyles>
		)
	return <Content />
}

const CardStyles = styled.div`
	width: 100%;
	height: 100%;
	${CardStyle}

	div {
		height: 100%;
	}
`
